/* unplugin-vue-components disabled */import script from "./ThemeSwitch.vue?vue&type=script&setup=true&lang=js"
export * from "./ThemeSwitch.vue?vue&type=script&setup=true&lang=js"

import "./ThemeSwitch.vue?vue&type=style&index=0&id=1e4088dd&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e4088dd"]])

export default __exports__